<template>
  <div class="card dashboard-widget bot-knowledge-widget">
    <div class="card bg-indigo-400 stat-card">
      <div class="card-header">BOT KNOWLEDGE</div>
      <div class="card-body">
        <div class="row">
          <div class="col-6 col-xl-3">
            <div class="media mt-2 mb-1">
              <div class="mr-3 align-self-center">
                <a class="btn bg-transparent rounded-round border-2 btn-icon">
                  <em class="icon-bubbles2"></em>
                </a>
              </div>
              <div class="media-body">
                <h3 class="mb-0">{{botKnowledgeData.trainedMessages || 0}}</h3>
                <span class="font-size-sm opacity-75">trained messages</span>
              </div>
            </div>
          </div>
          <div class="col-6 col-xl">
            <div class="media mt-2 mb-1">
              <div class="mr-3 align-self-center">
                <a class="btn bg-transparent rounded-round border-2 btn-icon">
                  <em class="icon-database2"></em>
                </a>
              </div>
              <div class="media-body">
                <h3 class="mb-0">{{botKnowledgeData.models || 0}}</h3>
                <span class="font-size-sm opacity-75">model(s)</span>
              </div>
            </div>
          </div>
          <div class="col-6 col-xl">
            <div class="media mt-2 mb-1">
              <div class="mr-3 align-self-center">
                <a class="btn bg-transparent rounded-round border-2 btn-icon">
                  <em class="icon-list2"></em>
                </a>
              </div>
              <div class="media-body">
                <h3 class="mb-0">{{botKnowledgeData.categories || 0}}</h3>
                <span class="font-size-sm opacity-75">categories</span>
              </div>
            </div>
          </div>
          <div class="col-6 col-xl">
            <div class="media mt-2 mb-1">
              <div class="mr-3 align-self-center">
                <a class="btn bg-transparent rounded-round border-2 btn-icon">
                  <em class="icon-tree5"></em>
                </a>
              </div>
              <div class="media-body">
                <h3 class="mb-0">{{botKnowledgeData.ruleSets || 0}}</h3>
                <span class="font-size-sm opacity-75">rule set(s)</span>
              </div>
            </div>
          </div>
          <div class="col-6 col-xl">
            <div class="media mt-2 mb-1">
              <div class="mr-3 align-self-center">
                <a class="btn bg-transparent rounded-round border-2 btn-icon">
                  <em class="icon-make-group"></em>
                </a>
              </div>
              <div class="media-body">
                <h3 class="mb-0">{{botKnowledgeData.rules || 0}}</h3>
                <span class="font-size-sm opacity-75">rules</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'bot-knowledge-widget',
  mounted() {
    this.loadBotKnowledge().then(() => {});
  },
  methods: {
    ...mapActions({
      loadBotKnowledge: 'dashboard/loadBotKnowledge',
    }),
  },
  computed: {
    ...mapGetters({
      botKnowledgeData: 'dashboard/botKnowledgeData',
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
